const images = {
  PixelArtVideo: require('./assets/videos/projects/pixel-art.mp4'),
  ColorGuessVideo: require('./assets/videos/projects/color-guess.mp4'),
  SolarSystemVideo: require('./assets/videos/projects/solarSystem.mp4'),
  toDoVideo: require('./assets/videos/projects/toDo.mp4'),
  TryunfoVideo: require('./assets/videos/projects/Tryunfo.mp4'),
  TrybeTunesVideo: require('./assets/videos/projects/Trybetunes.mp4'),
  FrontEndOnStoreVideo: require('./assets/videos/projects/front-end-online-store.mp4'),
  TrybewartsVideo: require('./assets/videos/projects/trybewarts.mp4'),
  ShopingCartVideo: require('./assets/videos/projects/shoping-cart.mp4')
}

export default images